import dayjs from 'dayjs'

export function formatDate(dateToFormat, showTime) {
    const formatType = showTime ? 'DD.MM.YYYY, HH:mm' : 'DD.MM.YYYY'
    const date = dayjs(dateToFormat).format('DD.MM.YYYY')
    if (!date || date === '30.12.1899' || date === '01.01.0001') {
        return '/'
    }
    return dayjs(dateToFormat).format(formatType)
}
